import React, { useState } from "react";
import { FaCheck, FaInfoCircle, FaMediumM, FaTimes } from "react-icons/fa";
import {
  FaInstagram,
  FaLinkedin,
  FaMedium,
  FaSquareXLinkedin,
} from "react-icons/fa6";
import { toast } from "react-toastify";
import { httpReauest } from "../../utils/httpRequest";

const MediumTask = ({ user, reward, getData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);

  const handleStartClick = () => {
    window.open("https://medium.com/@filetrust.io", "_blank");
  };

  const handleCheckClick = () => {
    setModalOpen(true);
  };

  const handleSubmitUsername = async () => {
    if (!username) {
      toast.error("Please enter your Medium username.");
      return;
    }

    setLoading(true);
    try {
      const userStorage = JSON.parse(localStorage.getItem("user"));

      await httpReauest(
        "POST",
        "/user/medium/username",
        { username },
        { "x-access-token": userStorage?.token }
      );

      toast.success("Successfull");
      getData();
      setModalOpen(false);
    } catch (err) {
      toast.error(err.response?.data?.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`${
        (user?.mediumFollow === "claimed" ||
          user?.mediumFollow === "progress") &&
        "order-last opacity-40"
      } flex justify-between gap-3 items-center relative border-b py-2 pb-4 text-white`}
    >
      <span className="flex items-center gap-2 lg:gap-4">
        <FaMediumM className="text-[32px] sm:text-[54px] lg:text-[72px]" />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2 flex items-center gap-2">
            Follow Medium{" "}
            <FaInfoCircle
              className="text-blue-400 cursor-pointer"
              onClick={() => setIsModalOpen(true)}
              title="Help"
            />
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />+{reward}
          </span>
        </span>
      </span>

      {user?.mediumFollow === "progress" ? (
        <>
          {" "}
          <button
            disabled
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            in Progress...
          </button>
        </>
      ) : user?.mediumFollow === "claimed" ? (
        <button
          disabled
          className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          <FaCheck color="green" /> Claimed
        </button>
      ) : (
        <div className="flex flex-col items-end gap-2">
          <div className="flex gap-2">
            <button
              onClick={handleStartClick}
              className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px]"
            >
              Start
            </button>
            <button
              onClick={handleCheckClick}
              className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px]"
            >
              Check
            </button>
          </div>
        </div>
      )}

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-[#1e293b] p-6 rounded-xl w-full max-w-md text-white shadow-xl">
            <h3 className="text-xl font-semibold mb-4">
              Enter your Medium username
            </h3>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Medium username"
              className="w-full px-4 py-2 rounded-lg bg-gray-800 border border-white/10 text-white mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 rounded bg-gray-600 hover:bg-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitUsername}
                disabled={loading}
                className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700"
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
          <div className="bg-[#1e293b] rounded-xl max-w-[90%] w-full sm:w-[400px] p-4">
            <div className="flex justify-between items-center mb-4 text-white">
              <h2 className="text-xl font-bold ">How Work This Task</h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-lg font-bold"
              >
                <FaTimes />
              </button>
            </div>
            <p className="text-gray-100 text-left">
              After you submit your username, it may take up to 10 minutes for the
              system to verify whether you have followed our Medium account.
              If your follow is confirmed, the reward will be automatically
              added to your account.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MediumTask;
